/**
 * Simple header for Favorites page.
 */
export const FavoritesHeader = () => {
  return (
    <div className="bg-surface border-b border-default">
      <div className="mx-auto max-w-7xl py-8 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl  tracking-tight text-main">Favorite Trips</h1>
        <p className="mt-2 text-sm text-muted">Trips you're following</p>
      </div>
    </div>
  );
};
